import { SOURCE_ID_TYPE_FILE, SOURCE_ID_TYPE_URL } from 'Constants/index'
import { useRecoilValue } from 'recoil'

import { Grid, GridCell } from 'mailup-web-components'
import BoxSetSource from './commonComponents/BoxSetSource'
import PanelContents from './commonComponents/PanelContents'
import PanelLastUpdated from './commonComponents/PanelLastUpdated'
import BoxFileUploader from './fileComponents/BoxFileUploader'
import BoxContentUpdates from './urlComponents/BoxContentUpdates'

import { sourceState } from '../recoil/state/source'

const Body = () => {
  const { idType } = useRecoilValue(sourceState)

  return (
    <>
      <Grid cols={12}>
        <GridCell span={6}>
          <PanelContents />
        </GridCell>
        <GridCell span={6}>
          <PanelLastUpdated />
        </GridCell>
      </Grid>
      <Grid cols={12}>
        <GridCell span={12}>
          <BoxSetSource />
        </GridCell>
      </Grid>
      <Grid cols={12}>
        <GridCell span={12}>
          {idType === SOURCE_ID_TYPE_URL && <BoxContentUpdates />}
          {idType === SOURCE_ID_TYPE_FILE && <BoxFileUploader />}
        </GridCell>
      </Grid>
    </>
  )
}

export default Body
